import { useDispatch } from "react-redux";
import { ACTIONS, SAGA_ACTIONS, createDispatchAction } from "../../../../_config";

export function useAppUserAction() {
  const dispatch = useDispatch();

  return {
    logout: createDispatchAction(dispatch, SAGA_ACTIONS.AUTH.LOGOUT),
    updateDisplayName: createDispatchAction(dispatch, ACTIONS.AUTH.UPDATE_DISPLAY_NAME),
    updateDob: createDispatchAction(dispatch, ACTIONS.AUTH.UPDATE_DOB),
    updateEmail: createDispatchAction(dispatch, ACTIONS.AUTH.UPDATE_EMAIL),
    setGuestUserId: createDispatchAction(dispatch, ACTIONS.AUTH.SET_GUEST_USER_ID),
    setPickIds: createDispatchAction(dispatch, ACTIONS.AUTH.SET_PICK_IDS),
  };
}
